import { Component, inject } from '@angular/core'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { Router, RouterModule } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { AuthService } from '../../../../services/auth.service'

@Component({
  selector: 'app-auth-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  imports: [ReactiveFormsModule, TranslatePipe, RouterModule]
})
export class AuthLogin {
  formBuilder = inject(FormBuilder)
  router = inject(Router)
  authService = inject(AuthService)
  isLoggingIn = false

  loginForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]]
  })
  isShowPwd = this.formBuilder.control(false)

  get email() {
    return this.loginForm.get('email')
  }

  get password() {
    return this.loginForm.get('password')
  }

  onLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched()
      return
    }
    this.isLoggingIn = true
    let { email, password } = this.loginForm.getRawValue()
    this.authService.login(email!, password!).subscribe({
      next: () => {
        this.isLoggingIn = false
        this.router.navigate(['schedule'])
      },
      error: () => {
        this.isLoggingIn = false
      }
    })
  }
}
